{
  "blocks": [
    {
      "id": "product-modern-fertility",
      "kind": "product",
      "tags": ["testing", "at-home", "her"],
      "title": "Ro / Modern Fertility",
      "icon": "🩸",
      "body": {
        "name": "Ro / Modern Fertility",
        "price": 159,
        "originalPrice": 199,
        "description": "At-home finger-prick test that measures several key fertility hormones and gives a personalised report about ovarian reserve and reproductive timeline, plus optional clinician follow-up.",
        "orderUrl": "https://ro.co/testing/fertility-hormone-test/",
        "imageUrl": "https://hoirqrkdgbmvpwutwuwj.supabase.co/storage/v1/object/public/assets/assets/fbfc1402-5bc1-4d06-aa83-a23d29482d9b_320w.webp",
        "chips": ["FSA/HSA eligible", "Results in 7-10 days"],
        "section": "ovarian-reserve"
      }
    },
    {
      "id": "product-letsgetchecked",
      "kind": "product",
      "tags": ["testing", "at-home", "her"],
      "title": "LetsGetChecked Ovarian Reserve",
      "icon": "🩸",
      "body": {
        "name": "LetsGetChecked Ovarian Reserve Test",
        "price": 139,
        "description": "Finger-prick blood test you do at home to measure AMH, giving an estimate of ovarian reserve. Sample is mailed to a lab; results and follow-up are available online.",
        "orderUrl": "https://www.letsgetchecked.com",
        "imageUrl": "https://hoirqrkdgbmvpwutwuwj.supabase.co/storage/v1/object/public/assets/assets/5dbaeedb-e56b-4f65-9a21-0780dd3fcee9_320w.webp",
        "chips": ["Results in 2-5 days", "FSA/HSA eligible"],
        "section": "ovarian-reserve"
      }
    },
    {
      "id": "product-letsgetchecked-hormone",
      "kind": "product",
      "tags": ["testing", "at-home", "her"],
      "title": "LetsGetChecked Female Hormone Test",
      "icon": "🩸",
      "body": {
        "name": "LetsGetChecked Female Hormone Test",
        "price": 139,
        "description": "Finger-prick test that looks at core reproductive hormones (such as FSH, LH, estradiol, prolactin) to help understand cycle patterns, ovulation issues, or symptoms like irregular periods.",
        "orderUrl": "https://www.letsgetchecked.com/home-female-hormone-test/",
        "imageUrl": "https://hoirqrkdgbmvpwutwuwj.supabase.co/storage/v1/object/public/assets/assets/5dbaeedb-e56b-4f65-9a21-0780dd3fcee9_320w.webp",
        "chips": ["Results in 2-5 days", "FSA/HSA eligible", "Free shipping"],
        "section": "ovarian-reserve"
      }
    },
    {
      "id": "product-semen-core",
      "kind": "product",
      "tags": ["testing", "at-home", "his", "sperm"],
      "title": "Core Semen Analysis",
      "icon": "🔬",
      "body": {
        "name": "Core Semen Analysis",
        "price": 149,
        "originalPrice": 250,
        "description": "At-home semen analysis processed by an accredited lab using WHO 2021 methodology. Measures sperm count, concentration, morphology, progressive and non-progressive motility, agglutination, immotile sperm, pH, and volume. Collect at home and mail it back with the prepaid label.",
        "chips": ["At-home", "Results in 3 days", "9 parameters"],
        "section": "semen-analysis",
        "panelKind": "core",
        "includedDataPointIds": [
          "dp-sperm-count",
          "dp-sperm-concentration",
          "dp-sperm-morphology",
          "dp-sperm-motility",
          "dp-sperm-non-progressive-motility",
          "dp-sperm-agglutination",
          "dp-sperm-immotile",
          "dp-semen-ph",
          "dp-semen-volume"
        ]
      }
    },
    {
      "id": "product-semen-post-vasectomy",
      "kind": "product",
      "tags": ["testing", "at-home", "his", "sperm"],
      "title": "Post-vasectomy check",
      "icon": "🔬",
      "body": {
        "name": "Post-vasectomy semen analysis",
        "price": 99,
        "originalPrice": 200,
        "description": "Confirms whether a vasectomy worked by checking for any remaining sperm. Measures count, concentration, motility, and volume, clinician reviewed at an accredited lab. Recommended about 12 to 16 weeks after surgery and after at least 20 ejaculations.",
        "chips": ["At-home", "Results in 3 days", "Clinician reviewed"],
        "section": "semen-analysis",
        "panelKind": "post-vasectomy",
        "includedDataPointIds": [
          "dp-sperm-count",
          "dp-sperm-concentration",
          "dp-sperm-motility",
          "dp-semen-volume"
        ]
      }
    },
    {
      "id": "product-semen-vasectomy-reversal",
      "kind": "product",
      "tags": ["testing", "at-home", "his", "sperm"],
      "title": "Vasectomy reversal check",
      "icon": "🔬",
      "body": {
        "name": "Vasectomy reversal semen analysis",
        "price": 149,
        "originalPrice": 250,
        "description": "Checks whether sperm has returned after a vasectomy reversal, and whether it looks healthy enough for conception. Measures count, concentration, motility, and volume. Recommended about 6 to 8 weeks after surgery.",
        "chips": ["At-home", "Results in 3 days", "Post-reversal"],
        "section": "semen-analysis",
        "panelKind": "vasectomy-reversal",
        "includedDataPointIds": [
          "dp-sperm-count",
          "dp-sperm-concentration",
          "dp-sperm-motility",
          "dp-semen-volume"
        ]
      }
    },
    {
      "id": "product-semen-antisperm",
      "kind": "product",
      "tags": ["testing", "at-home", "his", "sperm"],
      "title": "Antisperm antibody test",
      "icon": "🔬",
      "body": {
        "name": "Antisperm antibody test",
        "price": 229,
        "originalPrice": 300,
        "description": "Looks for antisperm antibodies, a hidden cause of male infertility often missed by a standard analysis, alongside a full semen analysis. Helpful after failed IVF or ICSI fertilization. Accredited lab, WHO 2021 methodology.",
        "chips": ["At-home", "Results in 3 days", "Immune factor"],
        "section": "semen-analysis",
        "panelKind": "advanced",
        "includedDataPointIds": [
          "dp-sperm-count",
          "dp-sperm-concentration",
          "dp-sperm-morphology",
          "dp-sperm-motility",
          "dp-sperm-non-progressive-motility",
          "dp-sperm-agglutination",
          "dp-sperm-immotile",
          "dp-semen-ph",
          "dp-semen-volume",
          "dp-antisperm-antibodies"
        ]
      }
    },
    {
      "id": "product-semen-dna-frag",
      "kind": "product",
      "tags": ["testing", "at-home", "his", "sperm"],
      "title": "Sperm DNA fragmentation",
      "icon": "🔬",
      "body": {
        "name": "Sperm DNA fragmentation test",
        "price": 399,
        "originalPrice": 500,
        "description": "Measures the DNA fragmentation index alongside a full semen analysis to reveal the quality of the genetic material inside sperm. High fragmentation can affect conception and pregnancy even when a standard analysis looks normal. Often considered after failed cycles, recurrent loss, or age over 40.",
        "chips": ["At-home", "Results in 10 days", "DNA integrity"],
        "section": "semen-analysis",
        "panelKind": "advanced",
        "includedDataPointIds": [
          "dp-sperm-count",
          "dp-sperm-concentration",
          "dp-sperm-morphology",
          "dp-sperm-motility",
          "dp-sperm-non-progressive-motility",
          "dp-sperm-agglutination",
          "dp-sperm-immotile",
          "dp-semen-ph",
          "dp-semen-volume",
          "dp-sperm-dna-fragmentation"
        ]
      }
    },
    {
      "id": "product-semen-dna-methylation",
      "kind": "product",
      "tags": ["testing", "at-home", "his", "sperm"],
      "title": "Sperm DNA methylation",
      "icon": "🔬",
      "body": {
        "name": "Sperm DNA methylation test",
        "price": 529,
        "originalPrice": 700,
        "description": "Combines a full semen analysis with an epigenetic DNA methylation assay that looks at how sperm DNA is programmed, beyond what a standard analysis can show. Useful when planning IUI or IVF, or when results look normal but conception is not happening.",
        "chips": ["At-home", "Results in ~3 weeks", "Epigenetic"],
        "section": "semen-analysis",
        "panelKind": "advanced",
        "includedDataPointIds": [
          "dp-sperm-count",
          "dp-sperm-concentration",
          "dp-sperm-morphology",
          "dp-sperm-motility",
          "dp-sperm-non-progressive-motility",
          "dp-sperm-agglutination",
          "dp-sperm-immotile",
          "dp-semen-ph",
          "dp-semen-volume",
          "dp-sperm-dna-methylation"
        ]
      }
    },
    {
      "id": "product-semen-complete",
      "kind": "product",
      "tags": ["testing", "at-home", "his", "sperm"],
      "title": "Complete Semen Analysis",
      "icon": "🔬",
      "body": {
        "name": "Complete Semen Analysis",
        "price": 869,
        "originalPrice": 1400,
        "description": "The most comprehensive panel. Combines the core semen analysis with antisperm antibody, DNA fragmentation index, and epigenetic DNA methylation testing in a single kit for a full picture of sperm health. Accredited lab, WHO 2021 methodology.",
        "chips": ["At-home", "Most complete", "12 parameters"],
        "section": "semen-analysis",
        "panelKind": "complete",
        "includedDataPointIds": [
          "dp-sperm-count",
          "dp-sperm-concentration",
          "dp-sperm-morphology",
          "dp-sperm-motility",
          "dp-sperm-non-progressive-motility",
          "dp-sperm-agglutination",
          "dp-sperm-immotile",
          "dp-semen-ph",
          "dp-semen-volume",
          "dp-antisperm-antibodies",
          "dp-sperm-dna-fragmentation",
          "dp-sperm-dna-methylation"
        ]
      }
    },
    {
      "id": "product-mira",
      "kind": "product",
      "tags": ["testing", "at-home", "her"],
      "title": "Mira Fertility Tracker",
      "icon": "📊",
      "body": {
        "name": "Mira Care",
        "price": 229,
        "description": "Reusable analyzer + smart test wands that measure multiple hormones (LH, estrogen metabolite E3G, and PdG) to track fertile window and ovulation with lab-grade quantitative readings in an app.",
        "orderUrl": "https://shop.miracare.com",
        "imageUrl": "https://hoirqrkdgbmvpwutwuwj.supabase.co/storage/v1/object/public/assets/assets/b4646b4c-b706-4a99-84c4-5781cf47fd1b_320w.webp",
        "chips": [
          "Digital analyzer",
          "App connected",
          "Instant results",
          "FSA/HSA eligible"
        ],
        "section": "cycle-monitoring"
      }
    },
    {
      "id": "product-everlywell",
      "kind": "product",
      "tags": ["testing", "at-home", "her"],
      "title": "Everlywell Women's Fertility Test",
      "icon": "🩸",
      "body": {
        "name": "Everlywell – Key hormones",
        "price": 149,
        "description": "At-home finger-prick kit measuring a focused set of fertility-related hormones to give insight into ovulation and ovarian function, with digital results and physician-reviewed reporting.",
        "orderUrl": "https://www.everlywell.com/products/womens-health-test/",
        "imageUrl": "https://hoirqrkdgbmvpwutwuwj.supabase.co/storage/v1/object/public/assets/assets/e73f5e2b-d3e0-4004-bda9-f154cda862f9_320w.webp",
        "chips": [
          "5 key fertility hormones",
          "Results in a few days",
          "FSA/HSA eligible"
        ],
        "section": "ovarian-reserve"
      }
    },
    {
      "id": "product-everlywell-broad",
      "kind": "product",
      "tags": ["testing", "at-home", "her"],
      "title": "Everlywell Women's Health Test",
      "icon": "🩸",
      "body": {
        "name": "Everlywell – Broader panel",
        "price": 249,
        "description": "Broader hormone panel that screens several sex and stress-related hormones to explore fatigue, cycle changes, low libido, or other symptoms that may affect overall reproductive health.",
        "orderUrl": "https://www.everlywell.com/products/womens-health-test/",
        "imageUrl": "https://hoirqrkdgbmvpwutwuwj.supabase.co/storage/v1/object/public/assets/assets/e73f5e2b-d3e0-4004-bda9-f154cda862f9_320w.webp",
        "chips": [
          "Finger-prick + saliva",
          "Measures 11 hormones",
          "CLIA-certified lab",
          "FSA/HSA eligible"
        ],
        "section": "ovarian-reserve"
      }
    },
    {
      "id": "product-mylab-box",
      "kind": "product",
      "tags": ["testing", "at-home", "her"],
      "title": "myLAB Box Fertility Test",
      "icon": "🩸",
      "body": {
        "name": "myLAB Box",
        "price": 149,
        "description": "Mail-in hormone test that checks key markers linked to ovarian reserve and ovulation, designed as a quick snapshot of whether hormone levels are in an expected range for fertility.",
        "orderUrl": "https://www.mylabbox.com",
        "imageUrl": "https://hoirqrkdgbmvpwutwuwj.supabase.co/storage/v1/object/public/assets/assets/7303b192-9f81-4d0a-abc0-dde05e78bcf0_320w.webp",
        "chips": ["Mail-in kit", "FSA/HSA eligible", "CLIA Certified"],
        "section": "ovarian-reserve"
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
